module.exports = __webpack_public_path__ + "img/synapse-homepage3.6013ffb4.png";